var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.875c.206 0 .375.17.375.375V4H1.375v-.75c0-.206.169-.375.375-.375zm.375 3.375v4.5a.376.376 0 0 1-.375.375H1.75a.376.376 0 0 1-.375-.375v-4.5zM1.75 1.75c-.827 0-1.5.673-1.5 1.5v7.5c0 .828.673 1.5 1.5 1.5h10.5c.827 0 1.5-.672 1.5-1.5v-7.5c0-.827-.673-1.5-1.5-1.5zm1.313 7.125a.56.56 0 0 0-.563.563c0 .312.25.562.563.562h1.124a.561.561 0 1 0 0-1.125zm3 0a.56.56 0 0 0-.563.563c0 .312.25.562.563.562h2.625a.561.561 0 1 0 0-1.125z"
  })));
};
export default SvgCreditCard;